import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const NotificationCard = ({ notification, onToggleReadStatus, onNavigate }) => {
  const getCategoryColor = (category) => {
    switch (category) {
      case 'campaign':
        return 'bg-blue-500/10 text-blue-600';
      case 'message':
        return 'bg-green-500/10 text-green-600';
      case 'payment':
        return 'bg-orange-500/10 text-orange-600';
      case 'proposal':
        return 'bg-purple-500/10 text-purple-600';
      default:
        return 'bg-gray-500/10 text-gray-600';
    }
  };

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'campaign':
        return 'Briefcase';
      case 'message':
        return 'MessageSquare';
      case 'payment':
        return 'DollarSign';
      case 'proposal':
        return 'FileText';
      default:
        return 'Bell';
    }
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date?.toLocaleDateString();
  };

  const handleToggleRead = (e) => {
    e?.stopPropagation();
    onToggleReadStatus?.(notification?.id, notification?.read);
  };

  return (
    <div
      className={`p-4 rounded-lg border transition-all ${
        notification?.read
          ? 'bg-background border-border' :'bg-primary/5 border-primary/20'
      } hover:shadow-md`}
    >
      <div className="flex items-start gap-3">
        <div className={`p-2 rounded-lg ${getCategoryColor(notification?.category)}`}>
          <Icon name={getCategoryIcon(notification?.category)} size={20} />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-1">
            <h4 className="font-semibold text-foreground text-sm">
              {notification?.title}
            </h4>
            {!notification?.read && (
              <span className="w-2 h-2 bg-primary rounded-full flex-shrink-0 mt-1"></span>
            )}
          </div>

          <p className="text-sm text-muted-foreground mb-2">
            {notification?.message}
          </p>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              {notification?.sender_name && (
                <span className="font-medium">{notification?.sender_name}</span>
              )}
              <span>•</span>
              <span>{formatTimestamp(notification?.created_at)}</span>
            </div>

            <div className="flex items-center gap-2">
              <Button
                variant="ghost"
                size="sm"
                onClick={handleToggleRead}
                className="opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <Icon
                  name={notification?.read ? 'Mail' : 'MailCheck'}
                  size={16}
                  className="text-muted-foreground"
                />
              </Button>
              {notification?.action_url && (
                <Button
                  variant="ghost"
                  size="xs"
                  onClick={() => onNavigate?.(notification?.action_url)}
                >
                  View
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationCard;